import React, { useEffect, useState } from "react";
import { Portal } from "react-portal";

export function TurnrPortal({ children, open, alwaysRenderContent }) {
    const [isClientSide, setIsClientSide] = useState(false);
    const [firstOpen, setFirstOpen] = useState(open);

    useEffect(() => {
        // this useEffect prevents showing Hydration Error
        if (!isClientSide) {
            setIsClientSide(true);
        }
    }, []);

    useEffect(() => {
        if (open && !firstOpen) {
            setFirstOpen(true);
        }
    }, [open, firstOpen]);

    return (
        isClientSide &&
        (firstOpen !== false || alwaysRenderContent) && (
            <Portal>
                <div
                    style={{
                        display: alwaysRenderContent && !firstOpen ? "none" : "block",
                    }}
                >
                    {children}
                </div>
            </Portal>
        )
    );
}
